var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c("div", { staticClass: "app-main-inner-row" }, [
      _c(
        "div",
        { staticClass: "filters" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": _vm.isZh ? "80px" : "125px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.labelName } },
                    [
                      (_vm.criteriaType === 3 || _vm.criteriaType === 4) &&
                      _vm.seaLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "Seaport",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      (_vm.criteriaType === 3 || _vm.criteriaType === 4) &&
                      _vm.airLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "Airport",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      (_vm.criteriaType === 3 || _vm.criteriaType === 4) &&
                      _vm.railLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "RailwayStation",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayStation,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 12
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "OverseaWarehouse",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_OverseaWarehouse,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 6
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "User",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "obj",
                              "default-value": _vm.criteriaValue,
                              "tag-name": "chineseName",
                              fields: ["chineseName"],
                              "options-width": "250px"
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 13
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "Office",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office,
                              "callback-params": { key: "criteriaValue" },
                              "default-value": _vm.criteriaValue,
                              "method-params": {},
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.code +
                                  "]" +
                                  (_vm.isZh
                                    ? item.chineseName
                                    : item.englishName)
                                )
                              },
                              "filter-tag-names": [
                                "code",
                                _vm.isZh ? "chineseName" : "englishName"
                              ],
                              "show-custom-label-in-option": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 5
                        ? _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            staticStyle: { width: "286px" },
                            attrs: { no: "HSCode", disabled: _vm.locked },
                            model: {
                              value: _vm.criteriaValue,
                              callback: function($$v) {
                                _vm.criteriaValue = $$v
                              },
                              expression: "criteriaValue"
                            }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 7
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "Customer",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { customer: true, active: true },
                              "callback-method-type": "value",
                              "default-value": _vm.criteriaValue,
                              "callback-params": { key: "customerId" }
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 8
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "SeaCmp",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { seaCmp: true, active: true },
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              },
                              "show-custom-label-in-option": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 9
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "BookingAgent",
                              filterable: "",
                              "options-width": "250px",
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 10
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "Region",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "callback-params": { key: "region" },
                              "callback-method-type": "value",
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 11
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "OverseaAgent",
                              filterable: "",
                              "tag-name": "englishName",
                              "options-width": "250px",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                active: true
                              },
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 14
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "ExchangeAgent",
                              filterable: "",
                              "options-width": "250px",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 15
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "DesignationAgent",
                              filterable: "",
                              "options-width": "250px",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                designationAgent: true,
                                active: true
                              },
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "Add",
                            disabled: _vm.locked,
                            type: "primary"
                          },
                          on: { click: _vm.add }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "Delete",
                            disabled: _vm.locked,
                            type: "danger"
                          },
                          on: { click: _vm.remove }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  ),
                  _vm.criteriaType === 6
                    ? _c(
                        "span",
                        {
                          staticStyle: { color: "red", "padding-left": "8px" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SchemeUserTips"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      {
        staticClass: "app-main-inner-row row-grid",
        staticStyle: { "min-height": "400px" }
      },
      [
        _c("cargo-ag-grid", {
          staticStyle: { width: "100%" },
          attrs: {
            "show-side-bar": false,
            "grid-params": _vm.gridParams,
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          },
          on: {
            "update:gridParams": function($event) {
              _vm.gridParams = $event
            },
            "update:grid-params": function($event) {
              _vm.gridParams = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }